import service from '@/store/services/employers/tariff-activity-service';

const state = {
    list: {},
    tariffActivity: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, tariffActivity) => {
        state.tariffActivity = tariffActivity;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },


    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(tariffActivity => {
                commit('SET_RESOURCE', tariffActivity);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(tariffActivity => {
                commit('SET_RESOURCE', tariffActivity);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((tariffActivity) => {
                commit('SET_RESOURCE', tariffActivity);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((tariffActivity) => {
                commit('SET_RESOURCE', tariffActivity);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    tariffActivity: state => state.tariffActivity,
    dropdown: (state) => {
        return state.list.map(tariffActivity => ({
            id: tariffActivity.id,
            name: tariffActivity.name
        }));
    }
};

const tariffActivities = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default tariffActivities;
